export default "__VITE_ASSET__BjppQ$gU__"